<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="充值时间：">
        <el-date-picker v-model="dataForm.dateStr" :picker-options="dataForm.pickerOptions" type="daterange"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :format="dataForm.formatTime"
          :value-format="dataForm.formatTime">
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" icon="el-icon-search" style="float: left;" @click="search"></el-button>
      <el-form-item style="float: right;">
        <el-button size="mini" icon="el-icon-back" @click="returnd()" style="font-size: 18px;"></el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" v-loading="loading" @selection-change="selectionChangeHandle" style="width: 100%;"
      height="calc(100% - 102px)" border stripe :header-cell-style="{ background: '#FAFAFA' }" placement="top">
      <el-table-column prop="id" header-align="center" align="center" label="充值编号">
      </el-table-column>
      <el-table-column prop="createTime" header-align="center" align="center" label="充值时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="endTime" header-align="center" align="center" label="到期时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="配送信息" align="center" header-align="center">
        <el-table-column prop="smsNumber" label="短信" align="center">
        </el-table-column>
        <el-table-column prop="voiceNumber" label="邮件" align="center">
        </el-table-column>
        <el-table-column prop="emailNumber" label="语音" align="center">
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      dataForm: {
        dateStr: new Date(),
        dateFromStr: '',
        dateToStr: '',
        formatTime: "yyyy-MM-dd",
      },
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      dataList: [],
      dataListSelections: [],
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    search() {
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.$moment(this.dataForm.dateStr[1]).add(1, 'days').format("yyyy-MM-DD") 
      }
      this.tableData = []
      this.pageIndex = 1; 
      if (this.dataForm.dateFromStr == undefined || this.dataForm.dateFromStr == ''){
        this.getDataList()
      }else{
        this.sousuo();
      }
    },
    // 获取数据列表
    getDataList() {
      this.loading = true
      //时间条件
      this.$http({
        url: this.$http.adornUrl("recharge/record"),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          // 'dateFromStr': this.dataForm.dateFromStr,
          // 'dateToStr': this.dataForm.dateToStr,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows;
          this.totalPage = data.data.total;
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg);
        }
        this.loading = false
        //重置参数
        this.dataForm.dateFromStr = '';
        this.dataForm.dateToStr = '';
      })
    },
    sousuo() {
      this.loading = true
      this.$http({
        url: this.$http.adornUrl("recharge/record"),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'dateFromStr': this.dataForm.dateFromStr + " 00:00:00",
          'dateToStr': this.dataForm.dateToStr + " 00:00:00",
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows;
          this.totalPage = data.data.total;
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg);
        }
        this.loading = false
        //重置参数
        this.dataForm.dateFromStr = '';
        this.dataForm.dateToStr = '';
      })
    },
    returnd() {
      this.$router.replace({ path: '/indexhome/management/index' });
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
  }
}
</script>
<style></style>


// WEBPACK FOOTER //
// src/pages/admincenter/management/alarmBalance.vue